import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconRotateComponent } from "./med-icon-rotate.component";

@NgModule({
  declarations: [
    MedIconRotateComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconRotateComponent,
  ],
})
export class MedIconRotateModule { }
